import * as React from 'react';
import { Dispatch } from 'redux';
import { UserViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as UserNormalizers from '../normalizers/userNormalizers';

export class GetUserRequest extends BaseApiGetRequest<
  UserViewModel,
  EntityNormalizers.NormalizedSingleEntity<UserNormalizers.NormalizedUsers>
> {
  constructor(userId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/users/${userId}`;
    this.normalizeMethod = UserNormalizers.normalizeSingleUser;
  }
}
